import { useContext, useMemo } from "react";
import {
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { HiOutlineExternalLink } from "react-icons/hi";

// Constants
import { CLICK_DEFI_UNSTAKE } from "constants/analytics";

// Contexts
import { StakeContext } from "providers/StakeProvider";

// Types
import { defiDetails } from "../types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  defiInfo: defiDetails;
  onProceed: () => void;
};

const ConfirmationModal = ({ isOpen, onClose, defiInfo, onProceed }: Props) => {
  const { hasAPY, partnerName, apy, link } = defiInfo;
  const { track } = useContext(StakeContext);

  const expectedAPY = useMemo(() => {
    const a = +apy;
    if (isNaN(a)) return `${apy}%`;
    return `${Math.ceil(a)}%`;
  }, [apy]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent w="408px" bg="brand.backgroundLight">
        <ModalCloseButton
          _focus={{
            boxShadow: "none",
          }}
        />
        <ModalBody py="1rem" mb="0.5rem">
          <Center flexDir="column">
            <Text
              fontSize="1.25rem"
              mt="56px"
              fontFamily="semi-bold"
              maxW={224}
              textAlign="center"
              lineHeight="24px"
            >
              MaticX on {partnerName} offers{" "}
              <Text as="span" color="#45BE21">
                {expectedAPY}{" "}
              </Text>
              {hasAPY ? "APY" : "APR"}
            </Text>
            <Text mt="0.5rem" color="brand.textInactive">
              Are you sure you want to unstake?
            </Text>
            <SimpleGrid columns={2} w="100%" gap="1rem" mt="2.5rem">
              <Button
                as="a"
                variant="outline"
                fontFamily="semi-bold"
                cursor="pointer"
                onClick={onProceed}
              >
                Unstake
              </Button>
              <Button
                as="a"
                bg="brand.primary"
                color="brand.textLight"
                href={link}
                target="_blank"
                rel="noreferrer"
                fontSize={{ base: "14px", lg: "1rem" }}
                onClick={() => {
                  track(CLICK_DEFI_UNSTAKE, {
                    partnerName,
                  });
                  onClose();
                }}
                fontFamily="semi-bold"
              >
                Go to {partnerName}{" "}
                <Text as="span" ml="0.5rem">
                  <HiOutlineExternalLink />
                </Text>
              </Button>
            </SimpleGrid>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
